// A canvas on a phone, as a column: its widgets in the order they sit on the board, each near its own height, and
// small ones (a number, a clock, a sticky) two to a row.

import { BUTTON_PHONE_H } from "../../shared/catalog";
import type { WidgetItem } from "../../shared/types";

export function columnOrder(items: WidgetItem[]): WidgetItem[] {
  // rows by vertical position, then left to right inside a row
  return [...items].sort((a, b) => {
    const rowA = Math.round(a.y / 120);
    const rowB = Math.round(b.y / 120);
    return rowA - rowB || a.x - b.x;
  });
}

const TALL = new Set(["feed", "tasks", "notes", "list", "table", "brief", "calendar", "map", "embed", "custom", "seo", "bookmarks", "agent", "habits", "links", "job"]);
/** Widgets that read well at half a phone's width, when they are small on the board too. */
const PAIRS = new Set(["metric", "goal", "clock", "countdown", "timer", "sun", "sticky"]);

/** How tall a widget is in the column: near its height on the board, within what a phone shows at once. */
export function phoneHeight(w: WidgetItem): number {
  if (w.type === "heading") return 56;
  // a Button is one line tall, a finger's height (Round 7)
  if (w.type === "action") return BUTTON_PHONE_H;
  return Math.max(110, Math.min(TALL.has(w.type) ? 420 : 260, Math.round(w.h * 0.92)));
}

const small = (w: WidgetItem) => PAIRS.has(w.type) && w.w <= 320 && w.h <= 300;

/** The column's rows: each widget on its own, or two small ones side by side, in column order. */
export function phoneRows(items: WidgetItem[]): (WidgetItem | [WidgetItem, WidgetItem])[] {
  const rows: (WidgetItem | [WidgetItem, WidgetItem])[] = [];
  for (let i = 0; i < items.length; i++) {
    const a = items[i];
    const b = items[i + 1];
    if (b && small(a) && small(b)) {
      rows.push([a, b]);
      i++;
    } else rows.push(a);
  }
  return rows;
}

/** A pair's height: the taller of the two, within what reads at half a phone's width. */
export function pairHeight(a: WidgetItem, b: WidgetItem): number {
  return Math.max(150, Math.min(220, Math.max(phoneHeight(a), phoneHeight(b))));
}
